document.addEventListener('DOMContentLoaded', () => {
    (function setupVideoSoundToggle() {
        const video = document.querySelector('video[data-metafield-video]');
        const btn = document.querySelector('button[data-video-btn]');
        if (!video || !btn) return;
        let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        function updateBtn() {
            btn.textContent = video.muted ? '🔇' : '🔊';
        }

        let hover = false;
        function showBtn() {
            btn.style.display = 'block';
            hover = true;
        }
        function hideBtn() {
            hover = false;
            setTimeout(() => {
                if (!hover) btn.style.display = 'none';
            }, 100);
        }

        video.addEventListener('mouseenter', () => {
            if (!isMobile) showBtn();
        });
        video.addEventListener('mouseleave', () => {
            if (!isMobile) hideBtn();
        });
        btn.addEventListener('mouseenter', () => {
            if (!isMobile) showBtn();
        });
        btn.addEventListener('mouseleave', () => {
            if (!isMobile) hideBtn();
        });

        video.addEventListener('touchstart', () => {
            if (isMobile) {
                btn.style.display = 'block';
                setTimeout(() => {
                    btn.style.display = 'none';
                }, 3000);
            }
        });

        btn.addEventListener('click', () => {
            video.muted = !video.muted;
            updateBtn();
        });

        updateBtn();
    })();
});